<script>
import Item from "./NochesAdicionalesItem.vue";
export default {
  props: {
    nochesAdicionales: {
      type: Array,
      required: true,
    },
  },
  components: {
    Item,
  },
  data() {
    return {
      cargando: false,
      error: false,
    };
  },
  methods: {
    async update({ numeroNochesAdicionales, codigoTipoHotel, serviceId }) {
      this.cargando = true;
      this.error = false;
      try {
        const data = await this.$parent.getOrUpdateOpciones({
          nochesAdicionales: {
            numeroNochesAdicionales,
            codigoTipoHotel,
            serviceId,
          },
        });
        if (data.error) {
          throw new Error(data.error);
        }
        this.$emit("update", data);
      } catch (e) {
        this.error = e.message;
      }
      this.cargando = false;
    },
  },
};
</script>

<template>
  <section class="nochesAdicionales" v-if="nochesAdicionales.length">
    <h3>Noches Adicionales</h3>
    <table class="table table-condensed" aria-hidden="true">
      <tbody>
        <Item
          v-for="noche in nochesAdicionales"
          :key="noche.idServicioCarga"
          :item="noche"
          :cargando="cargando"
          @update="update"
        />
      </tbody>
    </table>

    <div v-if="error" class="alert alert-danger">{{ error }}</div>
  </section>
</template>

<style lang="scss">
.nochesAdicionales {
  & {
    margin: 20px 0;
  }
  .alert-danger {
    display: block !important;
    word-wrap: break-word;
  }
}
</style>
